import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchFilingMembersTypes = getApiActionTypes(
  'FEDERAL_PRO_FORMA_FILING_GROUPS/FETCH_FILING_MEMBERS',
);
export const updateFilingMembersTypes = getApiActionTypes(
  'FEDERAL_PRO_FORMA_FILING_GROUPS/UPDATE_FILING_MEMBERS',
);
